import React from 'react';
import { InnerLabel, CheckboxWrapper, CheckboxSquare } from './styles';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {}

const Checkbox = ({
  children,
  checked,
  defaultChecked,
  onChange,
  ...inputProps
}: React.PropsWithChildren<Props>) => {
  return (
    <CheckboxWrapper>
      <input
        {...inputProps}
        type="checkbox"
        checked={checked}
        defaultChecked={defaultChecked}
        onChange={(ev) => {
          onChange && onChange(ev);
        }}
      />
      <CheckboxSquare />
      <InnerLabel>{children}</InnerLabel>
    </CheckboxWrapper>
  );
};

export default Checkbox;
